import { createFileRoute } from '@tanstack/react-router'
import { useBreadcrumbFromRoute } from '@/hooks/use-breadcrumb-from-route'

export const Route = createFileRoute('/_app/_crm/marketing')({
  component: MarketingPage,
})

function MarketingPage() {
  // Automatically sets breadcrumbs based on route configuration
  useBreadcrumbFromRoute()

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      <div className="rounded-lg border border-status-info-border bg-status-info-bg p-4 text-sm text-status-info-fg">
        <strong>Marketing features are coming soon.</strong>{' '}
        This page is in active development.
      </div>
      <div className="grid auto-rows-min gap-4 md:grid-cols-3">
        <div className="aspect-video rounded-xl bg-muted/50" />
        <div className="aspect-video rounded-xl bg-muted/50" />
        <div className="aspect-video rounded-xl bg-muted/50" />
      </div>
      <div className="min-h-svh flex-1 rounded-xl bg-muted/50 md:min-h-min" />
    </div>
  )
}
